import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import './Zuteilung_job.css';
import '../../../styles/CiTable.css';
import { host_url } from '../../../App'; // Import host_url
import BackArrow from '../../../BackArrow'; // Importiere die BackArrow-Komponente
import { MdKeyboardArrowDown } from 'react-icons/md';

function ZuteilungJob() {
  const [einheiten, setEinheiten] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [zuteilungen, setZuteilungen] = useState([]);
  const [selectedEinheit, setSelectedEinheit] = useState('');
  const [selectedJob, setSelectedJob] = useState('');

  // Job-Auswahl aus dem Cookie wiederherstellen. Die Einheit wird NICHT aus dem
  // Cookie gesetzt, sondern weiter unten automatisch auf die aktuelle bzw.
  // nächste Einheit vorausgewählt.
  useEffect(() => {
    const jobCookie = Cookies.get('selectedJob');
    if (jobCookie && /^\d+$/.test(jobCookie)) {
      setSelectedJob(jobCookie);
    }
  }, []);

  useEffect(() => {
    // /einheiten_mit_zeiten liefert zusätzlich Start/Ende, die wir für die
    // automatische Vorauswahl der aktuellen/nächsten Einheit brauchen.
    fetch(`${host_url}/einheiten_mit_zeiten`)
      .then(response => response.json())
      .then(data => setEinheiten(Array.isArray(data) ? data : []))
      .catch(error => console.error('Error fetching einheiten:', error));
  }, []);

  // Automatisch die aktuelle oder nächste Einheit vorauswählen.
  // Regel: gewählt wird die erste (chronologisch sortierte) Einheit, deren
  // Ende-Zeitpunkt noch in der Zukunft liegt – also die gerade laufende oder,
  // falls gerade keine läuft, die als nächstes beginnende Einheit. Sie bleibt
  // bis zu ihrem eigenen Ende ausgewählt. Sind alle Einheiten vorbei, wird die
  // letzte genommen.
  useEffect(() => {
    if (einheiten.length === 0) return;

    const tagesDatum = (e) => new Date(e.Datum).toISOString().split('T')[0];
    const startOf = (e) => new Date(`${tagesDatum(e)}T${e.Start}`);
    const endeOf = (e) => new Date(`${tagesDatum(e)}T${e.Ende}`);

    const now = new Date();
    const sortiert = [...einheiten].sort((a, b) => startOf(a) - startOf(b));
    const aktuelleOderNaechste =
      sortiert.find((e) => e.Start && e.Ende && endeOf(e) > now) ||
      sortiert[sortiert.length - 1];

    if (aktuelleOderNaechste) {
      const id = String(aktuelleOderNaechste.ID);
      setSelectedEinheit(id);
      Cookies.set('selectedEinheit', id);
    }
  }, [einheiten]);

  useEffect(() => {
    fetch(`${host_url}/jobs`)
      .then(response => response.json())
      .then(data => {
        const sortedData = data.sort((a, b) => a.Name.localeCompare(b.Name));
        setJobs(sortedData);
      })
      .catch(error => console.error('Error fetching jobs:', error));
  }, []);

  useEffect(() => {
    if (selectedEinheit || selectedJob) {
      setZuteilungen([]); // Reset zuteilungen before fetching new data
      const query = new URLSearchParams();
      if (selectedEinheit) query.append('einheitId', selectedEinheit);
      if (selectedJob) query.append('jobId', selectedJob);

      fetch(`${host_url}/zuteilungen?${query.toString()}`)
        .then(response => response.json())
        .then(data => setZuteilungen(data))
        .catch(error => console.error('Error fetching zuteilungen:', error));
    } else {
      setZuteilungen([]);
    }
  }, [selectedEinheit, selectedJob]);

  const handleEinheitChange = (e) => {
    setSelectedEinheit(e.target.value);
    Cookies.set('selectedEinheit', e.target.value);
  };

  const handleJobChange = (e) => {
    setSelectedJob(e.target.value);
    Cookies.set('selectedJob', e.target.value);
  };

  return (
    <div>
      <div className="page-header">
        <BackArrow to="/jobportal" />
        <h1>Kinder im Job</h1>
      </div>
      <div className="dropdown-form">
        <label>
          Einheit
          <div className={`dropdown-wrapper ${selectedEinheit ? 'filled' : ''}`}>
            <select id="einheit" name="einheit" value={selectedEinheit} onChange={handleEinheitChange}>
              <option value="">Wähle eine Einheit</option>
              {einheiten.map(einheit => (
                <option key={einheit.ID} value={einheit.ID}>{einheit.Name}</option>
              ))}
            </select>
            <MdKeyboardArrowDown className="dropdown-chevron" />
          </div>
        </label>
      </div>
      <div className="dropdown-form">
        <label>
          Job
          <div className={`dropdown-wrapper ${jobs.some(job => String(job.JobID) === String(selectedJob)) ? 'filled' : ''}`}>
            <select id="job" name="job" value={selectedJob} onChange={handleJobChange}>
              <option value="">Wähle einen Job</option>
              {jobs.map(job => (
                <option key={job.JobID} value={job.JobID}>{job.Name}</option>
              ))}
            </select>
            <MdKeyboardArrowDown className="dropdown-chevron" />
          </div>
        </label>
      </div>
      {!selectedEinheit && !selectedJob ? (
        <p>Wähle eine Einheit oder einen Job, um die Kinder zu sehen.</p>
      ) : zuteilungen.length === 0 ? (
        <p>Keine Zuteilungen gefunden.</p>
      ) : (
        <div className="ci-table-wrapper">
        <table className="ci-table">
          <thead>
            <tr>
              <th>Kind</th>
              <th>Zelt</th>
            </tr>
          </thead>
          <tbody>
            {zuteilungen.map(zuteilung => (
              <tr key={`${zuteilung.KindID}-${zuteilung.JobID}`}>
                <td>{zuteilung.KindName}</td>
                <td>{zuteilung.ZeltName}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      )}
    </div>
  );
}

export default ZuteilungJob;
